import React , { useState ,useEffect  , useRef }  from "react";
import { PlusIcon, MinusIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";
import Loaderanimation from 'components/ui/loaderanimation';
import {
useCompanyQueryQtrResult
} from 'data/company';
import {number_format,APP_URL , formatINR, capitalizeWords} from 'components/config/Common';

export default function QuarterResultSection({companyinfo,type}) {
      const [openSections, setOpenSections] = useState({});

      const containerRef = useRef(null);
      const [scrolled, setScrolled] = useState(false);
    // Map to store background color of each parent section
    const parentBgMap = {};

    const [viewType, setViewType] = useState('Standalone');
   
    useEffect(() => {
    // code runs whenever `type` changes
    console.log('Type changed:', type);
       if(type){
          setViewType(capitalizeWords(type));
        }else{
          setViewType('Standalone');
        }
   /* refetch({id:companyinfo?.id,type:(type?'Consolidated':'Non-Consolidated'),
              company_type:companyinfo?.company_type
    });
    */
  }, [type]);

    const toggleSection = (sectionno) => {
      setOpenSections((prev) => ({
        ...prev,
        [sectionno]: !prev[sectionno],
      }));
    };

    const {
      quarterlyresult,
      years_list,
      lable_array:labelArray,
      isLoading: loading,
      error,
      isFetching:ldnfetching,
      refetch,
    } = useCompanyQueryQtrResult({id:companyinfo?.id,type:(type?'Consolidated':'Non-Consolidated')    });

   // console.log("quarterlyresult",quarterlyresult);
    const getTypeByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.type : null;
};

 const getSecByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.section : null;
};


const getPostfixByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.postfix : null;
};

const getTextcssByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.textbold : null;
};

const getDecimalByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.decimal : null;
};


/** code for scrolling */
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      setScrolled(container.scrollLeft > 0);
    };

    container.addEventListener("scroll", handleScroll);

    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

   const selectedData = quarterlyresult?.[viewType] ?? {};
  const selectedYearlist = years_list?.[viewType] ?? {};

 // console.log("selectedData",selectedData);
  // console.log("ratio data",balancesheet);
const getMonthNumber = (dateStr) => {
  const [, monthStr] = dateStr.split(" ");
  const monthMap = {
    Jan: 1, Feb: 2, Mar: 3,
    Apr: 4, May: 5, Jun: 6,
    Jul: 7, Aug: 8, Sep: 9,
    Oct: 10, Nov: 11, Dec: 12,
  };
  return monthMap[monthStr];
};


  const getQuarterLabel = (dateStr) => {
  const m = getMonthNumber(dateStr);
  if (m >= 4 && m <= 6) return "bg-white";
  if (m >= 7 && m <= 9) return "bg-white";
  if (m >= 10 && m <= 12) return "bg-white";
  return "bg-gray-50";
};


  return (
      <section className="bg-white shadow-md z-50 rounded-xl py-5">
        <h2 className="text-2xl font-semibold px-5">Quarterly Results</h2>
        <div className="text-heading px-5"> Standalone Figures in Rs. Crores / {type? 
              <Link to={`${APP_URL}/company/${companyinfo?.symbol}`} className="text-accent underline ml-1">
                View Standalone
              </Link>
          : 
          <Link to={`${APP_URL}/company/${companyinfo?.symbol}/consolidated`} className="text-accent underline ml-1">
            View Consolidated
          </Link>} </div>
        <div className="py-4"></div>
        {ldnfetching?
        <div className="h-10 flex w-full justify-center"><Loaderanimation /></div>
        :
        <div ref={containerRef} class="relative overflow-x-auto bg-neutral-primary-soft shadow-xs rounded-base ">
            <table 
              
             class="w-full text-sm text-left border-0 rtl:text-right text-body">
                <thead class="bg-neutral-secondary-soft border-b border-default">
                    <tr >
                        <th scope="col" class="px-6 py-2">
                           
                        </th>
                         {Object.entries(selectedYearlist).map(([keyyear, valyear]) => (
                            <th scope="col" className={`px-6 py-2 ${getQuarterLabel(valyear)}`}>{valyear}</th>
                          ))}
                    </tr>
                </thead>
                <tbody>
                  {Object.keys(selectedData || {}).length === 0 ? (
                  <div className="p-5 text-heading"> data is not ready yet , please check again
                </div>
                    ) : (<>
                {Object.entries(selectedData).map(([period, qresults],index) => {
                    const type = getTypeByName(period); // or value.name
                  const sectionno = getSecByName(period);

                    const postfix = getPostfixByName(period);
                  const textbold = getTextcssByName(period);
                  const decimalval =  getDecimalByName(period);


                  // If this is a parent row → compute & store bg
                    if (type === "parent") {
                      parentBgMap[sectionno] =
                        index % 2 === 0
                          ? "bg-gray-50"
                          : "bg-neutral-secondary-soft";
                    }

                    // Now rowBg ALWAYS exists (because child uses parent's stored bg)
                    const rowBg = parentBgMap[sectionno] || "bg-white";

                  // Find all children belonging to this section
                  const children = Object.entries(selectedData).filter(
                    ([p, data]) => getSecByName(p) === sectionno && getTypeByName(p) === "child"
                  );
                   console.log("children lenght",children.length);
                  const hasChild = children.length > 0;
                  
                  return(<React.Fragment key={sectionno}>  
                   {type === "parent" &&
                   <tr 
                   className={`${rowBg} ${textbold} cursor-pointer ${openSections[sectionno] ? "border-t-2 " : ""}  `}
                  onClick={() => type === "parent" && toggleSection(sectionno)}                      >
                    
                      <td className={`px-6 py-2  sticky left-0 z-20 ${scrolled ? "bg-gray-100" : ""} `} >
                        <div className={`flex gap-1 whitespace-nowrap items-center ${openSections[sectionno] ? "text-accent " : "text-heading"} `}>{period}
                            {hasChild && (
                        <> {openSections[sectionno] ? (
                              <MinusIcon className="w-3 h-3 text-accent" />
                            ) : (
                              <PlusIcon className="w-3 h-3 text-accent" />
                            )}</>
                          )}
                          </div>
                        </td>


                      {Object.entries(qresults).map(([key, qresultsval]) => (
                         
                          <td className={`px-6 py-2 text-heading  text-wrap ${getQuarterLabel(key)} `} >{qresultsval ? <>{formatINR(qresultsval,decimalval)}{postfix}</> : null} </td>
                      ))}
                      </tr>
                    }
                      {openSections[sectionno] && type === 'child' &&
                       <tr 
                         className={`${rowBg}  cursor-pointer`}
>                    
                      <td className={`px-6 py-2 text-black flex gap-1 whitespace-nowrap items-center`} >
                        {period}
                        </td>
                      {Object.entries(qresults).map(([key, qresultsval]) => (
                         
                          <td className={`px-6 py-2 text-black whitespace-nowrap`} >{qresultsval ? <>{formatINR(qresultsval,decimalval)} {postfix} </>: null}</td>
                      ))}
                      </tr>}
                    
                   </React.Fragment>)
                })}
                </>
                        )}     
                </tbody>
            </table>
        </div>
        }
      </section> 
  );
}
